import { useNavigate } from "react-router-dom";
import { ArtButton } from "@art/shared-ui";
import AutoAwesomeRounded from "@mui/icons-material/AutoAwesomeRounded";

import styles from "../onboarding.module.scss";
import { PlatformIllustration } from "../../utils/onBoarding_svg";

export default function GetStarted(_props: any) {
  const navigate = useNavigate();

  const handleGetStartedClick = async () => {
    navigate("/onboarding/project-setup");
  };

  return (
    <section className={styles.hero}>
      <div className={`${styles.hero_copy} ${styles.reveal}`}>
        <span className={styles.eyebrow}>
          <AutoAwesomeRounded />
          Welcome to A Realtime Tech
        </span>

        <h1 className={styles.display}>
          Your real&#8209;time journey
          <br />
          <span className={styles.accent}>starts here.</span>
        </h1>

        <p className={styles.lede}>
          Experience the full power of A Realtime Tech from the start. A real-time platform built on smart
          technology and raw speed — connect your projects and teams, work smarter, and lead the way
          in today&rsquo;s fast-moving digital world.
        </p>

        <div className={styles.actions}>
          <ArtButton
            label="Get Started"
            dataQa="onboarding-get-started"
            fullWidth={false}
            onClick={handleGetStartedClick}
            sx={{ px: 4, py: 1.15 }}
          />
        </div>
      </div>

      <div className={`${styles.hero_art_wrap} ${styles.reveal} ${styles.delay_2}`}>
        <PlatformIllustration />
      </div>
    </section>
  );
}
